import { Component, effect } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslocoService } from '@jsverse/transloco';
import { PaymentMethodTokenInfo } from '../../../core/models/corporate/payment-method-token.model';
import { Plan } from '../../../core/models/corporate/plan.model';
import { CorporateService } from '../../../core/services/corporate.service';

@Component({
  selector: 'app-payment-confirmation',
  standalone: false,
  templateUrl: './payment-confirmation.component.html',
  styleUrl: './payment-confirmation.component.scss'
})
export class PaymentConfirmationComponent {

  currentPlan: Plan | null = null;
  currentMethodPayment: PaymentMethodTokenInfo | null = null;
  txtButton = '';

  constructor(
    public ref: DynamicDialogRef,
    private corporateService: CorporateService,
    public config: DynamicDialogConfig<{ currentMethodPayment: PaymentMethodTokenInfo, currentPlan: Plan }>,
    private transloco: TranslocoService,
  ) {
    this.txtButton = this.transloco.translate('paymentConfirmation.buy');
    const data = this.config.data;

    this.currentMethodPayment = data?.currentMethodPayment || null;
    this.currentPlan = data?.currentPlan || null;

    effect(() => {
      this.currentMethodPayment = corporateService.currentPaymentMethod();
      if (!this.currentMethodPayment) {
        corporateService.loadPaymentMethodToken().subscribe();
      }
    });
  }

  purchase() {
    this.ref.close(true);
  }

}
